import { tabularPropertiesCommonAdapts } from 'app/model/adapters/datasets/tabular-type.dataset.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { SapOpenHubTableDataset } from '../../dataset/sap-open-hub-table.dataset';
import { TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapOpenHubTableDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                openHubDestinationName: '*',
                excludeLastRequest: '*',
                baseRequestId: '*'
            }
        }
    }
})
export class SapOpenHubTableDatasetAdapter extends TabularTypeDatasetAdapter<SapOpenHubTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SapOpenHubTableDataset): Promise<Model.DatasetResource> {
        const modelDatasetResource = await this._toResourceInternal(dataset, Metamodel.modelFor(SapOpenHubTableDataset).name, 'openHubDestinationName');
        if (!dataset.isV2) {
            const modelDataset = this.properties(modelDatasetResource) as Model.SapOpenHubDataset;
            modelDataset.typeProperties.excludeLastRequest = ValueAdapter.toResource(dataset, SapOpenHubTableDataset.EXCLUDE_LAST_REQUEST);
            modelDataset.typeProperties.baseRequestId = ValueAdapter.toResource(dataset, SapOpenHubTableDataset.BASE_REQUEST_ID);
        }
        return modelDatasetResource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SapOpenHubTableDataset): Promise<SapOpenHubTableDataset> {
        const modelDataset = await this._toModelInternal(modelDatasetResource, dataset, Metamodel.modelFor(SapOpenHubTableDataset), 'openHubDestinationName');
        if (!modelDataset.isV2) {
            ValueAdapter.toModel(modelDataset, SapOpenHubTableDataset.EXCLUDE_LAST_REQUEST, modelDatasetResource.properties.typeProperties.excludeLastRequest);
            ValueAdapter.toModel(modelDataset, SapOpenHubTableDataset.BASE_REQUEST_ID, modelDatasetResource.properties.typeProperties.baseRequestId);
        }
        return modelDataset;
    }
}
